import classNames from 'classnames'
import PropTypes from 'prop-types'
import Skeleton from 'react-loading-skeleton'

const palette = {
    green:   { border: 'border-smgreen-dark',   text: 'text-smgreen-darker'  },
    blue:    { border: 'border-smblue-dark',    text: 'text-smblue-darker'   },
    orange:  { border: 'border-smorange-dark',  text: 'text-smorange-darker' },
    red:     { border: 'border-smred-dark',     text: 'text-smred-darker'    },
    yellow:  { border: 'border-smyellow-dark',  text: 'text-smyellow-darker' },
    purple:  { border: 'border-smpurple-dark',  text: 'text-smpurple-darker' },
    gray:    { border: 'border-smgray-dark',    text: 'text-smgray-darker'   }
}

const sizeMap = {
    lg:  'px-3 py-1 text-sm',
    md:  'px-2.5 py-0.5 text-xs',
    sm:  'px-2 py-0.5 text-[11px]',
    xs:  'px-1.5 py-0.5 text-[10px]'
}

function Badge({ isLoading, size, color, icon, noBreak, children }) {
    if (isLoading) {
        return (
            <Skeleton
                baseColor="#e4e4e7"
                highlightColor="#f4f4f5"
                borderRadius={6}
                height="100%"
                width={80}
            />
        )
    }

    const styles = palette[color] || palette.gray
    return (
        <span
            className={classNames(
                'inline-flex items-center gap-1 border rounded-md whitespace-nowrap select-none',
                styles.border,
                styles.text,
                sizeMap[size],
                { 'whitespace-nowrap': noBreak }
            )}
        >
            {icon}
            {children}
        </span>
    )
}

Badge.propTypes = {
    isLoading: PropTypes.bool,
    size: PropTypes.oneOf(['lg', 'md', 'sm', 'xs']).isRequired,
    color: PropTypes.oneOf([
        'green',
        'blue',
        'orange',
        'red',
        'yellow',
        'purple',
        'gray'
    ]),
    icon: PropTypes.node,
    noBreak: PropTypes.bool,
    children: PropTypes.node.isRequired
}

Badge.defaultProps = {
    isLoading: false,
    color: 'gray',
    icon: null,
    noBreak: false
}

export default Badge